import { isPlainObject } from 'lodash';

/**
 * Verifies the unknown value to be an object or not. Helps TypeScript understand that something is an Object:
 *
 * const provideExample = (data: unknown): string => {
 *   if (isRecord(data) && Array.isArray(data.examples) && data.examples.length) {
 *     const randomExampleIndex = Math.floor(Math.random() * data.examples.length);
 *
 *     return data.examples[randomExampleIndex];
 *   }
 *
 *   return '';
 * };
 *
 * @param recordCandidate
 */
export const isRecord = (recordCandidate: unknown): recordCandidate is Record<string, unknown> =>
  isPlainObject(recordCandidate);
